angular.module('storefrontApp')
    .controller('authorizationController', ['$scope', function ($scope) {
        $scope.data = {
            userName: '',
            firstName: '',
            lastName: '',
            email: '',
            confirmEmail: '',
            password: '',
            confirmPassword: '',
        };

        $scope.isPasswordValidByPattern = {};

        $scope.setForm = function (form) {
            $scope.form = form;
        };

        $scope.submit = function (event) {
            if (
                $scope.form.$invalid
                || $scope.data.password !== $scope.data.confirmPassword
                || $scope.data.email !== $scope.data.confirmEmail
                || !$scope.isPasswordValidByPattern
            ) {
                event.preventDefault();
                return false;
            }

            return true;
        };
    }]);
